import React, {useEffect, useRef, useState} from 'react';

import {withWidgetContext} from '../widgetContextProvider';

import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import SendMessageIcon from '../../../assets/svgComponents/SendMessageIcon';

import utilsService from '../../../services/utilsService';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './chatPlaceholderComponent.css';

const ChatPlaceholderComponent = ({
  widgetDto = {},
  widgetContext = {},
  onSend = () => {},
  showBottomBlur = false,
}) => {
  const [text, setText] = useState('');

  const chatTextAreaRef = useRef();

  useEffect(() => {
    const textAreaRef = chatTextAreaRef?.current;
    if (textAreaRef) {
      textAreaRef.rows = 1;
      if (text.length) {
        const textAreaLineHeight = parseInt(
          getComputedStyle(textAreaRef).lineHeight,
          10,
        );
        const totalLines = textAreaRef.scrollHeight / textAreaLineHeight;
        const totalRows = Math.min(
          VIDABOO_CONSTANTS.TEXT_AREA_MAX_ROWS,
          Math.floor(totalLines),
        );
        textAreaRef.rows = totalRows;
      }
      textAreaRef.scrollTop = textAreaRef.scrollHeight;
    }
  }, [text]);

  const onTextChange = (e) => {
    setText(e.target.value);
  };

  const handleSendBtn = () => {
    widgetContext.setPreChatClientMsgToSend(text);
    onSend();
  };

  const chatSeperatorText =
    widgetDto.widgetAppCtrlDto?.widgetEditableTexts?.[
      VIDABOO_CONSTANTS.WIDGET_EDITABLE_TEXTS.CHAT_WITH_US
    ] ?? 'Or chat with us';

  return widgetDto.widgetAppCtrlDto.widgetInteractionMode ===
    VIDABOO_CONSTANTS.WIDGET_INTERACTION_MODE.LIST_AND_CHAT ? (
    <div
      style={{
        boxShadow: `0px -20px 15px 25px ${utilsService.getColorHexByCssClass(
          '--et-team-primary-background-color',
        )}`,
      }}
      className={`et-chat-placeholder-container ${showBottomBlur ? 'et-chat-placeholder-container-shadow' : ''}`}>
      <div className="et-cpc-separator-container">
        <div className="et-cpc-separator" />
        <div className="et-cpc-separator-text-container">
          {chatSeperatorText}
        </div>
        <div className="et-cpc-separator" />
      </div>
      <div className="et-cpc-content-wrap">
        <div className="et-cpc-input-send-btn-wrap">
          <div className="et-cpc-input-wrap">
            <textarea
              ref={chatTextAreaRef}
              dir="auto"
              className="et-cpc-input"
              type="text"
              placeholder="Say something cool…"
              onChange={onTextChange}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  if (e.shiftKey) {
                    return;
                  } else {
                    handleSendBtn();
                  }
                }
              }}
            />
          </div>
          <div className="et-cpc-send-btn">
            <ButtonComponent
              image={
                <SendMessageIcon fillColor="var(--et-mentor-cta-primary-btn-text-color)" />
              }
              onClick={handleSendBtn}
            />
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default withWidgetContext(ChatPlaceholderComponent);
